import { ls } from '@/services/storage'
import { formatPhoneNumber44 } from '@/utils/filters'
import buttonGlobalPlayer from '@/components/button-global-player/button-global-player.vue'
import modalEntry from '@/components/modal-entry/modal-entry.vue'
import pinForm from '@/components/player-login/pin-form/pin-form.vue'

export default {
  components: {
    buttonGlobalPlayer,
    modalEntry,
    pinForm
  },
  data () {
    return {
      authorizeData: {
        // phoneNumber: '447232352523',
        // what: 'contact-support'
        // what: 'no-birthdate'
        // what: 'no-number'
        // what: 'not-18'
        // what: 'sms-sent'
      },
      showPinForm: true,
      showModalUpdateDetails: false
    }
  },
  computed: {
    showModalPhoneNumber () {
      return this.authorizeData.what === 'sms-sent'
    },
    showModalNoNumber () {
      return this.authorizeData.what === 'no-number'
    },
    showModalNoBirthdate () {
      return this.authorizeData.what === 'no-birthdate'
    },
    showModalNot18 () {
      return this.authorizeData.what === 'not-18'
    },
    showModalContactSupport () {
      return this.authorizeData.what === 'contact-support'
    }
  },
  async created () {
    if (window.location.pathname === '/login') {
      return
    }
    this._authorize()
  },
  methods: {
    async _authorize () {
      const code = ls.get('code-v2')
      if (code) {
        try {
          this.loadingErrorsReset()
          this.loadingStart()

          // const redirectUri = 'https://example.org'
          const redirectUri = `${window.location.origin}/login`
          const data = await this.$api.auth.authorize({ code, redirectUri })
          this.authorizeData = data

          // Save counter for passcode retry
          if (data.what === 'sms-sent') {
            this.$store.commit('passcode/set', { phoneNumber: data.phoneNumber, globalLogin: true })
          }
          // Login user
          if (data.token) {
            this.$store.commit('auth/setAuth', { ...data })
            this.$store.dispatch('players/loadAccount', { ignoreCache: true })
          }
        } catch (error) {
          this.$store.commit('passcode/delete')
          if (error.isUnauthorized()) {
            this.authorizeData = { what: 'sms-sent', phoneNumber: error.details.phoneNumber || '' }
            this.showPinForm = false
            if (error.details.accountLocked) {
              this.loadingErrors = [
                'Oops! You’ve entered the wrong PIN too many times so we’ve blocked your account to protect you. Please wait 48 hours to try again or contact customer.support@global.com'
              ]
            } else if (error.details.globalToken || error.details.userInfo) {
              this.loadingErrors = [
                'Oops! We have failed to login you in using Global Player. Please try again or contact customer.support@global.com'
              ]
            } else if (error.details.banned) {
              this.loadingErrors = ['Oops! Your account has been blocked. Please contact customer.support@global.com']
            }
          } else {
            this.loadingError(error)
          }
        } finally {
          ls.del('code-v2')
          this.loadingEnd()
        }
      } else {
        const cached = this.$store.state.passcode.storagePasscode
        if (cached && cached.phoneNumber && cached.globalLogin) {
          this.authorizeData = { what: 'sms-sent', phoneNumber: cached.phoneNumber }
        }
      }
    },
    async onPinEnter (passcode) {
      const payload = {
        phoneNumber: formatPhoneNumber44(this.authorizeData.phoneNumber),
        passcode
      }
      try {
        this.loadingErrorsReset()
        this.loadingStart()
        await this.$store.dispatch('auth/login', payload)
        this.$store.commit('passcode/delete')
        this.authorizeData = {}
      } catch (error) {
        if (error.isUnauthorized()) {
          if (error.details.accountLocked) {
            this.loadingErrors = [
              'Oops! You’ve entered the wrong PIN too many times so we’ve blocked your account to protect you. Please wait 48 hours to try again or contact customer.support@global.com'
            ]
            this.showPinForm = false
          } else {
            this.loadingErrors = ['Oops! That seems to be the wrong PIN. Please try entering it again or request a new PIN']
          }
        } else {
          this.loadingError(error)
        }
      } finally {
        this.loadingEnd()
      }
    },
    async onRequestNewPin () {
      try {
        this.loadingErrorsReset()
        this.loadingStart()
        const { phoneNumber } = this.authorizeData
        await this.$api.auth.passcode({ phoneNumber: formatPhoneNumber44(phoneNumber) })
        this.$store.commit('passcode/set', { phoneNumber, globalLogin: true })
      } catch (error) {
        if (error.isTooManyRequests()) {
          this.loadingErrors = ['Oops! Too many PIN requests, please try again in 24 hours']
          this.showPinForm = false
        } else {
          this.loadingError(error)
        }
      } finally {
        this.loadingEnd()
      }
    },
    loginWithGlobalPlayer () {
      this.$router.push({ name: 'login' })
    },
    onCloseModalPhoneNumber () {
      this.$store.commit('passcode/delete')
      this.authorizeData = {}
    },
    onClickUpdateDetails () {
      this.authorizeData = {}
      this.showModalUpdateDetails = true
      this.$router.push({ name: 'global-player-settings' })
    }
  }
}
